const e={small:{value:"1px"},medium:{value:"2px"},large:{value:"3px"}};export{e as outlineOffsets};
